/* ════════════════════════════════════════════════
   RAIMENT MEDIA — theme.js
   Vanilla, dependency-free. Native Shopify AJAX cart.
════════════════════════════════════════════════ */
(function () {
  'use strict';

  var routes = (window.theme && window.theme.routes) || {};
  var strings = (window.theme && window.theme.strings) || {};
  var moneyFormat = (window.theme && window.theme.moneyFormat) || '${{amount}}';

  /* ── Money formatting (mirrors Shopify's option_selection.js) ── */
  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    function defaultTo(num, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(num) || num == null) return 0;
      num = (num / 100).toFixed(precision);
      var parts = num.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cents = parts[1] ? decimal + parts[1] : '';
      return dollars + cents;
    }
    var match = moneyFormat.match(placeholderRegex);
    var token = match ? match[1] : 'amount';
    switch (token) {
      case 'amount': value = defaultTo(cents, 2); break;
      case 'amount_no_decimals': value = defaultTo(cents, 0); break;
      case 'amount_with_comma_separator': value = defaultTo(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = defaultTo(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = defaultTo(cents, 2, ' ', ','); break;
      default: value = defaultTo(cents, 2);
    }
    return moneyFormat.replace(placeholderRegex, value);
  }

  /* Whole-dollar amounts read cleaner in the drawer ($79 not $79.00). */
  function formatShort(cents) {
    var s = formatMoney(cents);
    return s.replace(/\.00(?!\d)/, '');
  }

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function esc(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* ════════════════════════════════
     TOAST
  ════════════════════════════════ */
  var toastTimer;
  function toast(message) {
    var el = $('#ToastRegion');
    if (!el) return;
    el.textContent = '✓ ' + message;
    el.hidden = false;
    requestAnimationFrame(function () { el.classList.add('is-visible'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      el.classList.remove('is-visible');
      setTimeout(function () { el.hidden = true; }, 300);
    }, 1800);
  }

  /* ════════════════════════════════
     FREE GIFT
     Config comes from layout/theme.liquid (window.theme.freeGift):
       variantId   – the Silver Blue Dragon Necklace variant given free
       value       – its selling price in cents (shown as "worth")
       qualifying  – variant IDs that unlock the gift (singles + bundles)
     The $0 price itself comes from the automatic Buy X Get Y discount
     "Free Silver Blue Dragon Necklace" (one per order). The gift line is
     added in the same request as the item that unlocks it, and removed in
     the same request as the last item that qualifies for it.
  ════════════════════════════════ */
  var GIFT_PROP = '_free_gift';
  function giftConfig() { return (window.theme && window.theme.freeGift) || null; }

  function isGiftLine(item, g) {
    g = g || giftConfig();
    return !!(g && item && item.variant_id === g.variantId && item.properties && item.properties[GIFT_PROP]);
  }

  function hasQualifier(cart, g) {
    g = g || giftConfig();
    if (!g || !cart || !cart.items) return false;
    for (var i = 0; i < cart.items.length; i++) {
      if (g.qualifying.indexOf(cart.items[i].variant_id) > -1) return true;
    }
    return false;
  }

  var giftSyncing = false;
  // Safety net for carts changed elsewhere. Returns a promise of { cart, changed }.
  function syncGift(cart) {
    var g = giftConfig();
    if (!g || !cart || !cart.items || giftSyncing) return Promise.resolve({ cart: cart, changed: false });

    var qualifies = hasQualifier(cart, g);
    var giftLines = cart.items.filter(function (i) { return isGiftLine(i, g); });
    var url = null, body = null;

    if (qualifies && !giftLines.length) {
      url = (routes.cart_add || '/cart/add') + '.js';
      var props = {}; props[GIFT_PROP] = 'Yes';
      body = { items: [{ id: g.variantId, quantity: 1, properties: props }] };
    } else if (!qualifies && giftLines.length) {
      url = (routes.cart_change || '/cart/change') + '.js';
      body = { id: giftLines[0].key, quantity: 0 };
    } else if (qualifies && giftLines.length && giftLines[0].quantity !== 1) {
      url = (routes.cart_change || '/cart/change') + '.js';
      body = { id: giftLines[0].key, quantity: 1 };
    }

    if (!url) return Promise.resolve({ cart: cart, changed: false });

    giftSyncing = true;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.ok; })
      .then(function (ok) {
        return fetch((routes.cart || '/cart') + '.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (fresh) {
            giftSyncing = false;
            // a second pass handles the rare case of more than one gift line
            if (ok && fresh.items.filter(function (i) { return isGiftLine(i, g); }).length > 1) {
              return syncGift(fresh).then(function (res) { return { cart: res.cart, changed: true }; });
            }
            return { cart: fresh, changed: ok };
          });
      })
      .catch(function () { giftSyncing = false; return { cart: cart, changed: false }; });
  }

  /* Reference price per unit for the "you save" figure: the compare-at
     price when it is higher than the selling price. The gift line uses
     its selling price, so the gift is valued at what the silver necklace
     actually sells for. */
  function unitReference(item, g) {
    var map = (window.theme && window.theme.compareAt) || {};
    var compare = map[item.variant_id] || 0;
    if (isGiftLine(item, g)) return item.original_price;
    return Math.max(compare, item.original_price);
  }

  function getCart() {
    return fetch((routes.cart || '/cart') + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  /* Add items and, when they unlock the gift, the gift line too, in ONE
     request. Resolves with the fresh cart. */
  function addItems(items) {
    var g = giftConfig();
    return getCart().then(function (cart) {
      var payload = items.slice();
      if (g) {
        var addsQualifier = items.some(function (i) { return g.qualifying.indexOf(parseInt(i.id, 10)) > -1; });
        var hasGift = cart.items.some(function (i) { return isGiftLine(i, g); });
        if ((addsQualifier || hasQualifier(cart, g)) && !hasGift) {
          var props = {}; props[GIFT_PROP] = 'Yes';
          payload.push({ id: g.variantId, quantity: 1, properties: props });
        }
      }
      return fetch((routes.cart_add || '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: payload })
      }).then(function (r) {
        return r.json().then(function (d) {
          if (!r.ok) { var err = new Error((d && d.description) || 'Could not add'); err.userMessage = err.message; throw err; }
          return getCart();
        });
      });
    }).then(function (cart) { return syncGift(cart); }).then(function (res) { return res.cart; });
  }

  /* Change one line and, when that leaves no qualifying item, remove the
     gift line in the SAME request. Resolves with the fresh cart. */
  function changeLine(key, qty) {
    var g = giftConfig();
    return getCart().then(function (cart) {
      var updates = {}; updates[key] = qty;
      if (g) {
        var stillQualifies = cart.items.some(function (i) {
          var q = i.key === key ? qty : i.quantity;
          return q > 0 && g.qualifying.indexOf(i.variant_id) > -1;
        });
        var giftLine = null;
        cart.items.forEach(function (i) { if (!giftLine && isGiftLine(i, g)) giftLine = i; });
        if (!stillQualifies && giftLine && giftLine.key !== key) updates[giftLine.key] = 0;
      }
      return fetch((routes.cart || '/cart') + '/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: updates })
      }).then(function (r) { if (!r.ok) throw new Error('update failed'); return r.json(); });
    }).then(function (cart) { return syncGift(cart); }).then(function (res) { return res.cart; });
  }

  /* The cart page is server-rendered. Swap in a fresh copy of its section
     (Section Rendering API) instead of reloading the whole page. */
  function rerenderCartPage() {
    var page = $('[data-cart-page]');
    if (!page) return Promise.resolve();
    var host = page.closest('[id^="shopify-section-"]');
    if (!host) { window.location.reload(); return Promise.resolve(); }
    var id = host.id.replace('shopify-section-', '');
    return fetch((routes.cart || '/cart') + '?section_id=' + encodeURIComponent(id), { headers: { 'Accept': 'text/html' } })
      .then(function (r) { if (!r.ok) throw new Error('render failed'); return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var inner = tmp.querySelector('#shopify-section-' + id);
        host.innerHTML = inner ? inner.innerHTML : tmp.innerHTML;
        $all('[data-animate]', host).forEach(function (el) { el.classList.add('is-in'); });
      })
      .catch(function () { window.location.reload(); });
  }

  function showCart(cart, openAfter) {
    Cart.render(cart);
    Cart.updateCount(cart.item_count);
    if (openAfter) Cart.open();
    return cart;
  }

  function cartTotals(cart) {
    var g = giftConfig();
    var reference = 0;
    cart.items.forEach(function (item) { reference += unitReference(item, g) * item.quantity; });
    var saved = Math.max(0, reference - cart.total_price);
    return { reference: reference, saved: saved };
  }

  /* ════════════════════════════════
     CART
  ════════════════════════════════ */
  var Cart = {
    open: function () {
      var drawer = $('#CartDrawer'), overlay = $('#CartOverlay');
      if (!drawer) return;
      overlay && overlay.classList.add('is-open');
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    },
    close: function () {
      var drawer = $('#CartDrawer'), overlay = $('#CartOverlay');
      overlay && overlay.classList.remove('is-open');
      drawer && drawer.classList.remove('is-open');
      drawer && drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    },
    add: function (id, quantity, button) {
      if (!id) { toast('Select a size first'); return; }
      var label = button && button.textContent;
      if (button) { button.disabled = true; button.dataset.loading = '1'; button.textContent = '…'; }
      addItems([{ id: id, quantity: quantity || 1 }])
        .then(function (cart) {
          if (button) { button.disabled = false; delete button.dataset.loading; if (label) button.textContent = label; }
          toast(strings.addedToCart || 'Added to cart');
          showCart(cart, true);
        })
        .catch(function (err) {
          if (button) { button.disabled = false; delete button.dataset.loading; if (label) button.textContent = label; }
          toast((err && err.userMessage) || 'Network error');
        });
    },
    refresh: function (openAfter) {
      return getCart()
        .then(function (cart) { return syncGift(cart); })
        .then(function (res) {
          // The cart page is server-rendered; refresh its section if the gift line changed.
          if (res.changed && $('[data-cart-page]')) rerenderCartPage();
          return showCart(res.cart, openAfter);
        });
    },
    updateCount: function (count) {
      $all('[data-cart-count]').forEach(function (el) { el.textContent = '[' + count + ']'; });
      // Visible header badge: show only when items exist
      $all('[data-cart-count-badge]').forEach(function (el) {
        el.textContent = count;
        el.style.display = count > 0 ? '' : 'none';
      });
      // Insert a badge if the header rendered without one (cart was empty on load)
      if (count > 0) {
        $all('.nav__cart').forEach(function (cartEl) {
          if (!cartEl.querySelector('[data-cart-count-badge]')) {
            var badge = document.createElement('span');
            badge.className = 'nav__cart-count';
            badge.setAttribute('data-cart-count-badge', '');
            badge.textContent = count;
            cartEl.insertBefore(badge, cartEl.firstChild);
          }
        });
      }
    },
    changeQty: function (key, qty) {
      return changeLine(key, qty).then(function (cart) {
        showCart(cart, false);
        if ($('[data-cart-page]')) rerenderCartPage();
        return cart;
      });
    },
    render: function (cart) {
      var body = $('#CartDrawerBody');
      if (!body) return;
      var freeBar = body.getAttribute('data-free-shipping') === 'true';
      if (!cart.item_count) {
        body.innerHTML =
          '<div class="cart-drawer__empty">' +
          '<div class="cart-drawer__empty-text">' + (strings.cartEmpty || 'Your cart is empty') + '</div>' +
          '<a class="btn-primary" href="' + (body.getAttribute('data-continue-url') || '/') + '">Browse the collection</a>' +
          '</div>';
        return;
      }

      var g = giftConfig();
      var qualifies = hasQualifier(cart, g);
      var giftInCart = !!(g && cart.items.some(function (i) { return isGiftLine(i, g); }));
      var totals = cartTotals(cart);

      var banner = '';
      if (g && giftInCart && qualifies) {
        banner =
          '<div class="cart-gift-banner is-unlocked">' +
          '<span class="cart-gift-banner__icon" aria-hidden="true">✓</span>' +
          '<span><strong>Free ' + esc(g.title) + ' added.</strong> Worth ' + formatShort(g.value) + ', yours free with this order.</span>' +
          '</div>';
      } else if (g && !qualifies) {
        banner =
          '<div class="cart-gift-banner">' +
          '<span class="cart-gift-banner__icon" aria-hidden="true">+</span>' +
          '<span>Add a Blue Dragon Opal or Opal and Gold necklace and get the <strong>' + esc(g.title) + '</strong> free.</span>' +
          '</div>';
      }

      var items = cart.items.map(function (item, i) {
        var gift = isGiftLine(item, g);
        var img = item.image
          ? '<img src="' + item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=160" alt="" loading="lazy">'
          : '';
        var opts = item.options_with_values
          ? item.options_with_values.map(function (o) { return o.value; }).filter(function (v) { return v !== 'Default Title'; }).join(' · ')
          : (item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '');

        var lineRef = unitReference(item, g) * item.quantity;
        var finalPrice = item.final_line_price;
        var priceHtml;
        if (finalPrice === 0 && lineRef > 0) {
          priceHtml = '<span class="cart-line__was">' + formatShort(lineRef) + '</span><span class="cart-line__now cart-line__now--free">FREE</span>';
        } else if (lineRef > finalPrice) {
          priceHtml = '<span class="cart-line__was">' + formatShort(lineRef) + '</span><span class="cart-line__now">' + formatShort(finalPrice) + '</span>';
        } else {
          priceHtml = '<span class="cart-line__now">' + formatShort(finalPrice) + '</span>';
        }

        if (gift) {
          return (
            '<div class="cart-line cart-line--gift" data-line="' + (i + 1) + '" data-key="' + esc(item.key) + '">' +
            '<div class="cart-line__media">' + img + '</div>' +
            '<div class="cart-line__info">' +
            '<span class="cart-line__tag">Free gift</span>' +
            '<div class="cart-line__name">' + esc(item.product_title) + '</div>' +
            '<div class="cart-line__price">' + priceHtml + '</div>' +
            '<div class="cart-line__gift-note">Included with your order</div>' +
            '</div></div>'
          );
        }

        return (
          '<div class="cart-line" data-line="' + (i + 1) + '" data-key="' + esc(item.key) + '">' +
          '<div class="cart-line__media">' + img + '</div>' +
          '<div class="cart-line__info">' +
          '<div class="cart-line__name">' + esc(item.product_title) + '</div>' +
          (opts ? '<div class="cart-line__variant">' + esc(opts) + '</div>' : '') +
          '<div class="cart-line__price">' + priceHtml + '</div>' +
          '<div class="cart-line__qty">' +
          '<button type="button" data-qty-down aria-label="Decrease">–</button>' +
          '<span>' + item.quantity + '</span>' +
          '<button type="button" data-qty-up aria-label="Increase">+</button>' +
          '</div>' +
          '<button type="button" class="cart-line__remove" data-remove>Remove</button>' +
          '</div></div>'
        );
      }).join('');

      var savings = '';
      if (totals.saved > 0) {
        savings =
          '<div class="cart-save">' +
          '<div class="cart-save__row"><span>Total value</span><span class="cart-save__was">' + formatShort(totals.reference) + '</span></div>' +
          '<div class="cart-save__row cart-save__row--you"><span>You save</span><span>' + formatShort(totals.saved) + '</span></div>' +
          '</div>';
      }

      body.innerHTML =
        (freeBar ? '<div class="cart-drawer__ship">Free shipping unlocked ✓</div>' : '') +
        banner +
        items +
        '<div class="cart-drawer__foot">' +
        savings +
        '<div class="cart-drawer__subtotal"><span>Subtotal</span><span>' + formatShort(cart.total_price) + '</span></div>' +
        '<div class="cart-drawer__note">✓ ' + (strings.cartNote || 'Free delivery · 30-day returns') + '</div>' +
        '<a class="cart-drawer__checkout" href="/checkout">Checkout · ' + formatShort(cart.total_price) + '</a>' +
        '</div>';
    }
  };
  window.RaimentCart = Cart;

  /* ════════════════════════════════
     PRODUCT — variant / size selection
  ════════════════════════════════ */
  function selectVariant(btn) {
    if (!btn || btn.classList.contains('is-sold-out')) return;
    var form = btn.closest('[data-product-form]');
    if (!form) return;
    $all('.size-btn', form).forEach(function (b) { b.classList.remove('is-selected'); b.setAttribute('aria-checked', 'false'); });
    btn.classList.add('is-selected');
    btn.setAttribute('aria-checked', 'true');

    var id = btn.getAttribute('data-variant-id');
    var input = $('[name="id"]', form);
    if (input && id) input.value = id;

    var price = btn.getAttribute('data-price');
    if (price) $all('[data-price-target]').forEach(function (el) { el.textContent = price; });

    var sizeLabel = btn.getAttribute('data-size') || btn.textContent.trim();
    $all('[data-selected-size]').forEach(function (el) { el.textContent = sizeLabel; });

    var available = btn.getAttribute('data-available') !== 'false';
    $all('[data-atc]', form).forEach(function (atc) {
      atc.disabled = !available;
      var lbl = atc.querySelector('[data-atc-label]');
      if (lbl) lbl.textContent = available ? (atc.getAttribute('data-add-label') || 'Add to cart') : (strings.soldOut || 'Sold out');
    });
  }

  /* ── Gallery thumb swap ── */
  function swapGallery(thumb) {
    var full = thumb.getAttribute('data-full');
    var main = $('#ProductMainImage');
    if (full && main) { main.src = full; main.srcset = ''; }
    var label = thumb.getAttribute('data-label');
    var tag = $('#ProductMainTag');
    if (tag && label) tag.textContent = label;
    $all('.product__thumb').forEach(function (t) { t.classList.remove('is-active'); });
    thumb.classList.add('is-active');
  }

  /* ════════════════════════════════
     BUNDLE / CROSS-SELL ("complete the trio")
  ════════════════════════════════ */
  function recomputeBundle(bundle) {
    if (!bundle) return;
    var base = parseInt(bundle.getAttribute('data-base-price'), 10) || 0;
    var total = base, count = 1;
    $all('[data-bundle-variant]', bundle).forEach(function (cb) {
      if (cb.checked) { total += parseInt(cb.getAttribute('data-bundle-price'), 10) || 0; count++; }
    });
    var totalEl = bundle.querySelector('[data-bundle-total]');
    var countEl = bundle.querySelector('[data-bundle-count]');
    if (totalEl) totalEl.textContent = formatMoney(total);
    if (countEl) countEl.textContent = count;
  }

  function addBundle(button) {
    var bundle = button.closest('[data-bundle]');
    if (!bundle) return;
    var ids = [{ id: button.getAttribute('data-base-variant'), quantity: 1 }];
    $all('[data-bundle-variant]', bundle).forEach(function (cb) {
      if (cb.checked) ids.push({ id: cb.getAttribute('data-bundle-variant'), quantity: 1 });
    });
    button.disabled = true;
    addItems(ids)
      .then(function (cart) { button.disabled = false; toast('Bundle added'); showCart(cart, true); })
      .catch(function (err) { button.disabled = false; toast((err && err.userMessage) || 'Network error'); });
  }

  /* ════════════════════════════════
     STICKY ADD-TO-CART
  ════════════════════════════════ */
  function initStickyATC() {
    var sticky = $('[data-sticky-atc]');
    var sentinel = $('[data-atc-sentinel]');
    if (!sticky || !sentinel || !('IntersectionObserver' in window)) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        // show the bar once the main ATC has scrolled out of view upward
        if (!e.isIntersecting && e.boundingClientRect.top < 0) {
          sticky.classList.add('is-visible');
          sticky.setAttribute('aria-hidden', 'false');
        } else {
          sticky.classList.remove('is-visible');
          sticky.setAttribute('aria-hidden', 'true');
        }
      });
    }, { threshold: 0 });
    observer.observe(sentinel);
  }

  /* ════════════════════════════════
     COUNTDOWN ("order in HH:MM:SS posted today")
  ════════════════════════════════ */
  function initCountdown() {
    var els = $all('[data-countdown]');
    if (!els.length) return;
    function pad(n) { return String(n).padStart(2, '0'); }
    function tick() {
      var now = new Date();
      var end = new Date(now); end.setHours(17, 0, 0, 0);
      var diff = end - now; if (diff < 0) diff += 86400000;
      var h = Math.floor(diff / 3.6e6), m = Math.floor((diff % 3.6e6) / 6e4), s = Math.floor((diff % 6e4) / 1000);
      var str = pad(h) + ':' + pad(m) + ':' + pad(s);
      els.forEach(function (el) { el.textContent = str; });
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ════════════════════════════════
     PRODUCT RECOMMENDATIONS (Search & Discovery)
  ════════════════════════════════ */
  function initRecommendations() {
    var el = $('[data-recommendations]');
    if (!el) return;
    var sectionId = el.getAttribute('data-section-id');
    var productId = el.getAttribute('data-product-id');
    var limit = el.getAttribute('data-limit') || 3;
    if (!sectionId || !productId) return;
    var url = '/recommendations/products?section_id=' + encodeURIComponent(sectionId) +
              '&product_id=' + encodeURIComponent(productId) + '&limit=' + limit;
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html.trim();
        var fresh = tmp.querySelector('.related-products');
        if (fresh && fresh.querySelector('.product-card')) {
          el.innerHTML = fresh.innerHTML;
          el.hidden = false;
          if (document.body.classList.contains('anim-on')) el.classList.add('is-in');
        }
      })
      .catch(function () { /* leave hidden */ });
  }

  /* ════════════════════════════════
     SCROLL-IN ANIMATIONS
  ════════════════════════════════ */
  function initAnimations() {
    if (!document.body.classList.contains('anim-on')) return;
    var nodes = $all('[data-animate]');
    if (!('IntersectionObserver' in window)) {
      nodes.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    nodes.forEach(function (el) { io.observe(el); });
  }

  /* ════════════════════════════════
     DELEGATED EVENTS
  ════════════════════════════════ */
  document.addEventListener('click', function (e) {
    var t = e.target;

    var sizeBtn = t.closest('.size-btn');
    if (sizeBtn) { e.preventDefault(); selectVariant(sizeBtn); return; }

    var thumb = t.closest('.product__thumb');
    if (thumb) { e.preventDefault(); swapGallery(thumb); return; }

    var bundleAdd = t.closest('[data-bundle-add]');
    if (bundleAdd) { e.preventDefault(); addBundle(bundleAdd); return; }

    var atc = t.closest('[data-atc]');
    if (atc) {
      e.preventDefault();
      var form = atc.closest('[data-product-form]');
      var input = form && $('[name="id"]', form);
      Cart.add(input && input.value, 1, atc);
      return;
    }

    if (t.closest('[data-cart-open]')) {
      e.preventDefault();
      if (document.body.getAttribute('data-cart-type') === 'page') { window.location.href = routes.cart_url || '/cart'; return; }
      Cart.refresh(true);
      return;
    }
    if (t.closest('[data-cart-close]') || t.id === 'CartOverlay') { e.preventDefault(); Cart.close(); return; }

    /* Cart page +/- and Remove links: change by AJAX (gift handled in the
       same request), then refresh the section in place. The link's own
       href is the fallback if anything fails. */
    var pageChange = t.closest('[data-cart-page-change]');
    if (pageChange) {
      e.preventDefault();
      var pKey = pageChange.getAttribute('data-key');
      var pQty = parseInt(pageChange.getAttribute('data-qty'), 10);
      $all('[data-cart-page-change]').forEach(function (a) { a.style.pointerEvents = 'none'; a.style.opacity = '.5'; });
      Cart.changeQty(pKey, Math.max(0, pQty))
        .catch(function () { window.location.href = pageChange.href; });
      return;
    }

    var qtyUp = t.closest('[data-qty-up]'), qtyDown = t.closest('[data-qty-down]'), remove = t.closest('[data-remove]');
    if (qtyUp || qtyDown || remove) {
      var line = t.closest('[data-line]');
      if (!line) return;
      var key = line.getAttribute('data-key');
      var qtyEl = line.querySelector('.cart-line__qty span');
      var current = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
      var next = remove ? 0 : (qtyUp ? current + 1 : Math.max(0, current - 1));
      line.style.opacity = '.5';
      if (key) {
        Cart.changeQty(key, next).catch(function () { line.style.opacity = ''; toast('Network error'); });
      } else {
        // server-rendered line without a key: look it up by position
        var idx = parseInt(line.getAttribute('data-line'), 10);
        getCart().then(function (c) {
          var item = c.items[idx - 1];
          if (item) return Cart.changeQty(item.key, next);
        }).catch(function () { line.style.opacity = ''; toast('Network error'); });
      }
      return;
    }

    if (t.closest('[data-size-guide-open]')) { e.preventDefault(); var sg = $('#SizeGuide'); if (sg) { sg.classList.add('is-open'); sg.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; } return; }
    if (t.closest('[data-size-guide-close]') || t.id === 'SizeGuide') { e.preventDefault(); var sg2 = $('#SizeGuide'); if (sg2) { sg2.classList.remove('is-open'); sg2.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; } return; }
    var dialog = t.closest('.modal__dialog'); if (dialog) e.stopPropagation();

    var faqTrigger = t.closest('.faq-item__trigger');
    if (faqTrigger) {
      var faqItem = faqTrigger.closest('.faq-item');
      var faqOpen = faqItem.classList.contains('is-open');
      // Close siblings (one open at a time)
      var list = faqItem.closest('.faq__list');
      if (list) $all('.faq-item', list).forEach(function (it) { it.classList.remove('is-open'); var b = it.querySelector('.faq-item__trigger'); if (b) b.setAttribute('aria-expanded', 'false'); });
      if (!faqOpen) { faqItem.classList.add('is-open'); faqTrigger.setAttribute('aria-expanded', 'true'); }
      return;
    }

    var acc = t.closest('.accordion__trigger');
    if (acc) {
      var item = acc.closest('.accordion__item');
      var isOpen = item.classList.contains('is-open');
      var span = acc.querySelector('span');
      item.classList.toggle('is-open');
      acc.setAttribute('aria-expanded', String(!isOpen));
      if (span) span.textContent = isOpen ? '+' : '–';
      return;
    }

    if (t.closest('[data-menu-open]')) { e.preventDefault(); var md = $('#MenuDrawer'), mo = $('#MenuOverlay'); md && md.setAttribute('aria-hidden', 'false'); mo && mo.classList.add('is-open'); document.body.style.overflow = 'hidden'; return; }
    if (t.closest('[data-menu-close]') || t.id === 'MenuOverlay') { e.preventDefault(); var md2 = $('#MenuDrawer'), mo2 = $('#MenuOverlay'); md2 && md2.setAttribute('aria-hidden', 'true'); mo2 && mo2.classList.remove('is-open'); document.body.style.overflow = ''; return; }
  });

  /* ════════════════════════════════
     BUNDLE & SAVE TILES
     The tile button's own handler (main-product.liquid) submits the product
     form natively, which loads the cart page and then needs a second load
     for the gift. This capture-phase listener runs first and replaces that
     with one AJAX add (bundle + gift together) and opens the drawer.
  ════════════════════════════════ */
  document.addEventListener('click', function (e) {
    var cta = e.target && e.target.closest && e.target.closest('[data-bundle-upsell-cta]');
    if (!cta) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    if (cta.disabled || cta.dataset.loading) return;

    var group = cta.closest('[data-bundle-upsell-group]');
    var tile = group && (group.querySelector('[data-bundle-select].is-selected') || group.querySelector('[data-bundle-select].is-highlight') || group.querySelector('[data-bundle-select]'));
    if (!tile || tile.getAttribute('data-available') === 'false') return;

    var items;
    try { items = JSON.parse(tile.getAttribute('data-items') || '[]'); } catch (err) { items = []; }
    items = (items || []).filter(function (i) { return i && i.id; });
    if (!items.length) return;

    var label = cta.textContent;
    function reset() { delete cta.dataset.loading; cta.disabled = false; cta.textContent = label; }
    cta.dataset.loading = '1';
    cta.disabled = true;
    cta.textContent = 'Adding…';
    addItems(items)
      .then(function (cart) {
        reset();
        toast('Bundle added');
        showCart(cart, true);
      })
      .catch(function (err) {
        reset();
        toast((err && err.userMessage) || 'Network error');
      });
  }, true);

  /* "Free Silver Blue Dragon Necklace included" under the bundle button,
     only on pages that show the gift block (the qualifying products). */
  function initBundleGiftNote() {
    var g = giftConfig();
    if (!g || !$('[data-free-gift]')) return;
    $all('[data-bundle-upsell-cta]').forEach(function (cta) {
      var next = cta.nextElementSibling;
      if (next && next.classList.contains('bundle-upsell__gift')) return;
      var note = document.createElement('p');
      note.className = 'bundle-upsell__gift';
      note.innerHTML = '<span aria-hidden="true">✓</span> Free ' + esc(g.title) + ' included';
      cta.insertAdjacentElement('afterend', note);
    });
  }

  document.addEventListener('change', function (e) {
    var cb = e.target.closest('[data-bundle-variant]');
    if (cb) {
      var row = cb.closest('[data-bundle-row]');
      if (row) row.classList.toggle('is-on', cb.checked);
      var check = row && row.querySelector('.bundle__check');
      if (check) check.textContent = cb.checked ? '✓' : '';
      recomputeBundle(cb.closest('[data-bundle]'));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      Cart.close();
      var sg = $('#SizeGuide'); if (sg) { sg.classList.remove('is-open'); sg.setAttribute('aria-hidden', 'true'); }
      var md = $('#MenuDrawer'); if (md) md.setAttribute('aria-hidden', 'true');
      var mo = $('#MenuOverlay'); if (mo) mo.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  });

  /* ── Header height var for sticky offsets ── */
  function setHeaderHeight() {
    var header = $('.site-header');
    if (header) document.documentElement.style.setProperty('--header-h', header.offsetHeight + 'px');
  }

  document.addEventListener('DOMContentLoaded', function () {
    setHeaderHeight();
    initStickyATC();
    initRecommendations();
    initAnimations();
    initBundleGiftNote();
    Cart.refresh(false);
  });
  window.addEventListener('resize', setHeaderHeight);

  /* Other theme paths that open the drawer by event rather than through
     Cart.add still get the gift synced. */
  var eventTimer = null, eventOpen = false;
  ['cart:refresh', 'cart:open', 'cart-drawer:open', 'cart:updated'].forEach(function (name) {
    document.addEventListener(name, function () {
      if (name === 'cart:open' || name === 'cart-drawer:open') eventOpen = true;
      clearTimeout(eventTimer);
      eventTimer = setTimeout(function () { var o = eventOpen; eventOpen = false; Cart.refresh(o); }, 80);
    });
  });
})();
